import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { debounce } from 'lodash'
import { Avatar, Image, Row, Select, Space, Spin, Tag } from 'antd'

import {
    projectsList,
    projectsState,
    changePage as changeProjectPage,
} from '../../projects/projects.slice'
import { changePage, teamListGet, teamState } from '../../team/team.slice'
import {
    dateRangesList,
    projectReportsState,
} from '../../reports/projectReports/projectReports.slice'

import { CrossIcon } from '../../../assets/icons'
import DateFilter from './dateFilter'
import { getAllUserReportList, setDrawerFilter, setTableData } from '../store/finalReports.slice'
import InfiniteScrollSelect from '../../../components/InfiniteScrollSelect/InfiniteScrollSelect'
import { usersList, usersState } from '../../users/users.slice'
import EditReport from '../../reports/reportsTimeSheet/EditReport'
import { unique } from '../../../utils/commonUtils'

const { Option } = Select

const ReportFilters = ({ name, setShowWorkReport, showWorkReport }) => {
    const dispatch = useDispatch()

    const { pageLimit, currentPage, skipPage, isNext, projects, status } =
        useSelector(projectsState)
    const { tableData } = useSelector((state) => state.finalReportsSlice)
    const { reportDrawerFilterData } = useSelector((state) => state.finalReportsSlice)
    const { filter } = useSelector(projectReportsState)
    const [selectedUsers, setSelectedUsers] = useState([])
    const [isEditReport, setIsEditReport] = useState(false)
    const [searchPerformed, setSearchPerformed] = useState(false)
    const [isSearch, setIsSearch] = useState(false)
    const [selectedUserObjects, setSelectedUserObjects] = useState([])




    const {
        teamList,
        teamListLoading,
        skipPage: teamSkipPage,
        currentPage: teamCurrentPage,
        pageLimit: teamPageLimit,
        isNext: teamIsNext,
    } = useSelector(teamState)


    const {
        users,
    } = useSelector(usersState)

    const [state, setState] = useState({
        filteredAssignees: [],
        filteredProjects: [],
        filteredUsers: [],
        selectAssignees: [],
        selectProjects: [],
    })
    const [searchValue, setSearchValue] = useState('')

    const selectedProjectId =
        tableData?.projectId?.[0]?.value ||
        tableData?.projectId?.[0] ||
        ''

    const userOptions = selectedProjectId
        ? state.filteredAssignees
        : state.filteredUsers

    useEffect(() => {
        dispatch(usersList({ limit: 100, skip: 0 }))
    }, [])


    const mergedUserOptions = [
        ...userOptions,
        // ...selectedUserObjects.filter(
        //     (u) => !userOptions.some((opt) => opt.value === u.value)
        // ),
    ]

    // useEffect(() => {
    //     if (selectedUsers?.length && mergedUserOptions?.length) {
    //         const newlySelected = mergedUserOptions?.filter((user) =>
    //             selectedUsers?.includes(user.value)
    //         );
    //         setSelectedUserObjects(newlySelected);
    //         setState((prev) => ({
    //             ...prev,
    //             selectAssignees: newlySelected,
    //         }));
    //     }
    // }, [selectedUsers]);
    useEffect(() => {
        if (selectedUsers?.length && mergedUserOptions?.length) {
            const newlySelected = mergedUserOptions.filter((user) =>
                selectedUsers.includes(user.value)
            );

            setSelectedUserObjects((prev) => {
                // merge old with new without duplicates
                const merged = [...prev, ...newlySelected].filter(
                    (v, i, arr) => arr.findIndex((u) => u.value === v.value) === i
                );
                return merged;
            });

            setState((prev) => ({
                ...prev,
                selectAssignees: selectedUsers.map(
                    (id) => mergedUserOptions.find((u) => u.value === id) || prev.selectAssignees.find((u) => u.value === id)
                ).filter(Boolean),
            }));
        }
    }, [selectedUsers]);
    useEffect(() => {
        if (
            Array.isArray(tableData?.userId) &&
            tableData.userId.length > 0
        ) {
            setSelectedUsers(tableData?.userId)

        }
    }, [tableData?.projectId]);

    useEffect(() => {
        if (
            Array?.isArray(tableData?.projectId) &&
            tableData?.projectId.length > 0 &&
            tableData?.projectId[0] !== undefined &&
            tableData?.projectId[0] !== null
        ) {
            setState((prev) => ({
                ...prev,
                selectProjects: tableData.projectId[0],
            }));
        }
    }, [tableData?.projectId]);
    useEffect(() => {
        if (selectedUsers?.length == 0) {

            if (state.selectProjects.length !== 0) {
                if (Array.isArray(teamList) && teamList.length > 0) {
                    const filterUsers = teamList.map(
                        ({ name, _id, profilePicture, designation }) => ({
                            label: name,
                            value: _id,
                            profilePicture,
                            designation
                        })
                    )
                    setState((prev) => ({
                        ...prev,
                        selectAssignees: filterUsers
                    }))
                }
            }
        }
    }, [teamList, state.selectAssignees == 0])

    useEffect(() => {
        if (state.selectProjects.length == 0) {
            if (state.selectAssignees.length == 0) {
                if (Array.isArray(users)) {
                    const filterUsers = users.map(
                        ({ name, _id, profilePicture, designation }) => ({
                            label: name,
                            value: _id,
                            profilePicture,
                            designation
                        })
                    )
                    setState((prev) => ({
                        ...prev, selectAssignees
                            : filterUsers
                    }))
                }
            }
        }
    }, [users, state.selectProjects, state.selectAssignees])

    useEffect(() => {
        if (Array.isArray(users)) {
            const allUsers = users.map(({ name, _id, profilePicture, designation }) => ({
                label: name,
                value: _id,
                profilePicture,
                designation
            }))
            setState((prev) => ({ ...prev, filteredUsers: allUsers }))
        }
    }, [users])

    useEffect(() => {
        if (Array.isArray(teamList)) {
            const filterUsers = teamList.map(
                ({ name, _id, profilePicture, designation }) => ({
                    label: name,
                    value: _id,
                    profilePicture,
                    designation
                })
            )
            setState((prev) => ({ ...prev, filteredAssignees: filterUsers }))
        }
    }, [teamList])

    useEffect(() => {
        if (Array.isArray(projects)) {
            const newProjects = projects.map(
                ({ name, _id, projectProfile }) => ({
                    label: name,
                    value: _id,
                    projectProfile,
                })
            )
            setState((prev) => ({
                ...prev,

                filteredProjects: !isSearch ? unique([...prev.filteredProjects, ...newProjects], "value") : [...newProjects]
            }))
        }
    }, [projects])

    const fetchMoreProjects = (page, searchText = '') => {
        const nextSkip = (page - 1) * pageLimit
        dispatch(changeProjectPage({ currentPage: page, skip: nextSkip, pageLimit }))
        dispatch(projectsList({ limit: pageLimit, skip: nextSkip, search: searchText, }))
    }

    const debouncedFetchProject = useCallback(
        debounce((value) => {
            dispatch(projectsList({ skip: 0, limit: pageLimit, search: value, isSearch: true }))
            if (value) {
                setIsSearch(true)
            } else {
                setIsSearch(false)

            }
        }, 600),

        [dispatch, pageLimit]
    )

    const debouncedFetchUser = useCallback(
        debounce((value, projectId) => {
            if (projectId) {

                dispatch(
                    teamListGet({
                        skip: 0,
                        limit: teamPageLimit,
                        search: value,
                        projectId,
                    })
                )
            } else {
                dispatch(usersList({ limit: 100, skip: 0, search: value, }))
            }
        }, 600),
        [dispatch, teamPageLimit]
    )
    // useEffect(() => {
    //     setState((prevState) => ({
    //         ...prevState,
    //         selectAssignees: [],
    //         selectProjects:
    //             Array.isArray(tableData?.projectId) && tableData.projectId.length > 0
    //                 ? tableData.projectId[0]
    //                 : [],
    //     }));
    // }, [tableData?.projectId]);



    const tagRender = ({ label, value, closable, onClose }) => {
        const user = selectedUserObjects.find((u) => u.value === value)
        const initials = user?.label
            ?.split(' ')
            .map((n) => n[0]?.toUpperCase())
            .join('')

        return (
            <div style={styles.tag}>
                {user?.profilePicture ? (
                    <Avatar size={20} src={user.profilePicture} style={{ marginRight: 6 }} />
                ) : (
                    <Avatar size={20} style={styles.avatarFallback}>
                        {initials}
                    </Avatar>
                )}
                <span style={styles.label}>{user?.label}</span>
                {closable && (
                    <span
                        onClick={onClose}
                        style={{ cursor: 'pointer', display: 'flex', marginLeft: "4px" }}
                    >
                        <CrossIcon width={8} color={'#252525'} />
                    </span>
                )}
            </div>
        )
    }

    return (
        <>

            <Row
                align="middle"
                justify="space-between"
                style={{ flexFlow: 'nowrap' }}
            >
                <Row
                    align="middle"
                    style={{ columnGap: '20px', flexFlow: 'nowrap', width: '100%' }}
                >
                    <InfiniteScrollSelect
                        style={{ minWidth: '250px' }}
                        value={
                            tableData?.projectId?.length > 0
                                ? tableData.projectId[0]
                                : undefined
                        }
                        className='reports_project_selecter'
                        onChange={(selected) => {
                            setSelectedUsers([])
                            // dispatch(setTableData({ ...tableData, projectId: [selected], page: 0 }))
                            dispatch(setTableData({ ...tableData, projectId: [selected], userId: [], page: 0 }))
                            // dispatch(getAllUserReportList({
                            //     ...tableData,
                            //     projectId: selected ? [selected?.value] : [],
                            // }))
                            const updatedFilter = {
                                ...reportDrawerFilterData,
                                projectId: selected,
                            }

                            dispatch(setDrawerFilter(updatedFilter))
                            if (!selected) {
                                setState((prevState) => ({
                                    ...prevState,
                                    selectAssignees: [],
                                    selectProjects: [],
                                    // filteredAssignees: [],
                                }))
                            }

                            if (selected) {
                                setState((prevState) => ({
                                    ...prevState,
                                    selectAssignees: [],
                                    selectProjects: selected,
                                    // filteredAssignees: [],
                                }))

                                dispatch(teamListGet({
                                    skip: 0,
                                    limit: teamPageLimit,
                                    search: '',
                                    projectId: selected ? selected?.value : '',
                                }))
                            }
                        }}
                        onOpen={() => debouncedFetchProject('')}
                        placeholder="Select a Project"
                        data={state.filteredProjects}
                        isNext={isNext}
                        loading={status === 'loading'}
                        currentPage={currentPage}
                        search={searchValue}
                        fetchMore={fetchMoreProjects}
                        onSearch={(val) => {
                            setSearchValue(val)
                            debouncedFetchProject(val)
                        }}
                        renderOption={({ projectProfile, label }) => (
                            <Space>
                                {projectProfile ? (
                                    <Image
                                        src={projectProfile}
                                        width={24}
                                        height={24}
                                        preview={false}
                                        style={{ borderRadius: '50%' }}
                                    />
                                ) : (
                                    <Avatar size={24}>{label?.[0]}</Avatar>
                                )}
                                <span>{label}</span>
                            </Space>
                        )}
                    />

                    <Select
                        showSearch
                        size="small"
                        mode="multiple"
                        placeholder="Select a User"
                        className="reports_user_selecter"
                        rootClassName="p-0-multiSelect"
                        tagRender={tagRender}
                        filterOption={false}
                        onSearch={(val) => {
                            setSearchPerformed(!!val)
                            debouncedFetchUser(val, selectedProjectId)
                        }}
                        onChange={(selected) => {
                            setSelectedUsers(selected)

                            const newlySelected = mergedUserOptions.filter((user) =>
                                selected.includes(user.value)
                            )

                            const merged = [
                                ...selectedUserObjects.filter((u) => selected.includes(u.value)),
                                ...newlySelected,
                            ]

                            // Remove duplicates by value
                            const unique = Array.from(
                                new Map(merged.map((u) => [u.value, u])).values()
                            )

                            setSelectedUserObjects(unique)

                            dispatch(setTableData({ ...tableData, userId: selected, page: 0 }))
                            setState((prevState) => ({
                                ...prevState,
                                selectAssignees: unique,
                            }))

                            if (searchPerformed) {
                                debouncedFetchUser('', selectedProjectId)
                                setSearchPerformed(false)
                            }
                        }}
                        value={selectedUsers}
                        style={{ width: '100%', borderRadius: '8px' }}
                        notFoundContent={
                            teamListLoading || status === 'loading' ? (
                                <Spin size="small" />
                            ) : mergedUserOptions.length === 0 ? (
                                'No User found'
                            ) : null
                        }
                    >
                        {mergedUserOptions.map(({ value, label, profilePicture }) => (
                            <Option value={value} key={value}>
                                <Row align="middle" style={{ columnGap: '10px' }}>
                                    {profilePicture ? (
                                        <Image
                                            src={profilePicture}
                                            width={25}
                                            height={25}
                                            style={{
                                                borderRadius: '50%',
                                                objectFit: 'cover',
                                                minWidth: '25px',
                                            }}
                                            preview={false}
                                        />
                                    ) : (
                                        <Avatar style={{ backgroundColor: '#d9d9d9' }}>
                                            {label?.split(' ').map((n) => n[0]).join('')}
                                        </Avatar>
                                    )}
                                    {label}
                                </Row>
                            </Option>
                        ))}
                    </Select>

                </Row>

                <DateFilter
                    props={{
                        dateRangesList,
                        name,
                        selectedProject: state.selectProjects,
                        selectAssignees: state.selectAssignees,
                        filteredProjects: state.filteredProjects,
                        setIsEditReport,
                        setShowWorkReport: setShowWorkReport
                    }}
                />
            </Row>
            {/* <EditReport
                isEditReport={isEditReport}
                setIsEditReport={setIsEditReport}
            /> */}
        </>
    )
}

const styles = {
    tag: {
        display: 'flex',
        alignItems: 'center',
        background: '#f5f5f5',
        borderRadius: 10,
        padding: '4px 8px 4px 4px',
        margin: '4px 2px',
        maxWidth: '100%',
        border: '1px solid #afafaf80',
    },
    avatarFallback: {
        backgroundColor: 'rgb(0 10 129 / 25%)',
        color: '#000',
        fontSize: 9,
        marginRight: 6,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 22,
        height: 22,
    },
    label: {
        fontSize: 12,
        fontWeight: 500,
        color: '#333',
        marginRight: 4,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: 100,
    },
}

export default ReportFilters
